// preloadImages.ts
export const preloadImages = (imageUrls: string[]) => {
    return Promise.all(
        imageUrls.map(
            (url) =>
                new Promise<void>((resolve, reject) => {
                    const img = new Image();
                    img.src = url;
                    img.onload = () => resolve();
                    img.onerror = (err) => {
                        console.error(`Failed to load image at URL: ${url}`, err);
                        resolve(); // still resolve to avoid blocking others
                    };
                }),
        ),
    );
};
